import * as yup from 'yup';

// Mirrors Disbursement::Contracts::Macros::Amount::WHOLE_DIGITS. Past this the
// backend rejects on precision before it ever reaches the withdrawal limit, and
// past 21 digits the amount reaches it as exponent notation it cannot coerce at
// all — so the same reason is given here, before anything is sent.
const MAX_WHOLE_DIGITS = 14;
export const AMOUNT_MAX_DIGITS_MESSAGE = `Amount must be up to ${MAX_WHOLE_DIGITS} digits`;

export const withdrawalRequestDialogSchema = yup
  .object({
    virtual_account_number: yup
      .string()
      .label('Account')
      .required('Please select account'),
    withdrawal_account: yup
      .object()
      .shape({
        id: yup.string().required('Please select a withdrawal account')
      })
      .label('Bank account')
      .required('Please select a withdrawal account'),
    end_to_end_id: yup.string().label('End-to-end ID').required(),
    currency_code: yup.string().label('Currency'),
    amount: yup
      .string()
      .matches(/^[^0].*$/, 'Amount must be without leading zero')
      .matches(/^([0-9]*[.])?[0-9]+$/, 'Amount must be a number')
      .typeError('Amount must be a number')
      .test(
        'withdrawal-amount-whole-digits',
        AMOUNT_MAX_DIGITS_MESSAGE,
        (value) => (value ?? '').split('.')[0].length <= MAX_WHOLE_DIGITS
      )
      .label('Amount')
      .required()
  })
  .required();
